import { render, staticRenderFns } from "./BookingList.vue?vue&type=template&id=0dad12bf&scoped=true"
import script from "./BookingList.vue?vue&type=script&lang=ts"
export * from "./BookingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad12bf",
  null
  
)

export default component.exports